// extracted by mini-css-extract-plugin
module.exports = {"root":"root-26DyQ","label":"label-Y7xp9"};